import { render, staticRenderFns } from "./OperatorDashboard.vue?vue&type=template&id=81428bd4&scoped=true"
import script from "./OperatorDashboard.vue?vue&type=script&lang=js"
export * from "./OperatorDashboard.vue?vue&type=script&lang=js"
import style0 from "./OperatorDashboard.vue?vue&type=style&index=0&id=81428bd4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81428bd4",
  null
  
)

export default component.exports